import React, { Component, Fragment } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Image from '../../../config/images/gambar';
import { parserText } from '../../../config/utils';
import { getUser } from '../../../services/api-services/krs-api';
import { getSemester } from '../../../services/api-services/filterdropdown';
import { getNilai } from '../../../services/api-services/khs-api';
import ProdiSwitch from './ProdiSwitch';
import DateIndo from '../../../config/dateIndo';
import { validasiEvaluasi } from '../../../services/api-services/evaluasi-api';
import { sendMessage } from '../../../config/utils/message';

var nowDate = new Date();
var tanggal = DateIndo(nowDate);

class Khs extends Component {

    state = {
        ttd1: "",
        ttd2: "",
        ttdu1: '',
        ttdu2: '',
        prodi: '',
        nama: '',
        bahasa: '',
        user: [],
        listSemester: [],
        listNilai: [],
        listDetailNilai: [],
        detailNilai: [],
        nilai: [],
        isLoading: false,
        modalData: [],
        selectedSemester: '-',
        dataMhs: [],

    }

    // handle to print 
    print = (bahasa, prodi) => {
        this.setState({
            bahasa
        }, () => {
            const doc = new jsPDF();

            var imageAsia = Image.data

            doc.addImage(imageAsia, 'JPEG', 95, 6, 19, 19)

            var width = doc.internal.pageSize.getWidth()
            doc.setFont("Times-bold", "bold")
            doc.setFontSize(11.5);
            doc.text('INSTITUT TEKNOLOGI DAN BISNIS ASIA MALANG', width / 2, 31, { align: 'center' });

            let fakultas;
            if (bahasa == 'indonesia') {
                if (prodi == "Teknik Informatika" || prodi == "Sistem Komputer" || prodi == "Desain Komunikasi Visual") {
                    fakultas = "FAKULTAS TEKNOLOGI DAN DESAIN"
                } else if (prodi == "Akuntansi" || prodi == "Manajemen") {
                    fakultas = "FAKULTAS EKONOMI DAN BISNIS"
                }
            } else if (bahasa == "english") {
                if (prodi == "Teknik Informatika" || prodi == "Sistem Komputer" || prodi == "Desain Komunikasi Visual") {
                    fakultas = "FACULTY OF TECHNOLOGY AND DESIGN"
                } else if (prodi == "Akuntansi" || prodi == "Manajemen") {
                    fakultas = "FACULTY OF ECONOMY AND BUSINESS"
                }
            }
            doc.setFont("Times-bold", "bold");
            doc.setFontSize(11.5);
            doc.text(fakultas, width / 2, 36.5, { align: 'center' });

            let jalan;
            if (bahasa == 'indonesia') {
                jalan = 'Jl. Soekarno-Hatta, Rembuksari 1A Malang Telp.(0341) 478877 Fax.(0341) 4345225'
            } else if (bahasa == "english") {
                jalan = 'Soekarno-Hatta Street, Rembuksari 1A Malang Telp.(0341) 478877 Fax.(0341) 4345225'
            }
            doc.setFont("Times-Roman", "normal");
            doc.setFontSize(11.5);
            doc.text(jalan, width / 2, 41.5, { align: 'center' });

            doc.setLineWidth(0.1)
            doc.line(10, 47, 200, 47)

            doc.setFont("Times-bold", "bold");
            doc.setFontSize(11.5);

            let judul;
            if (bahasa == 'indonesia') {
                judul = "KARTU HASIL STUDI"
            } else if (bahasa == "english") {
                judul = "STUDY RESULT CARD"
            }
            doc.text(judul, width / 2, 56, { align: 'center' });

            let drawCell = function (data) {
                var doc = data.doc;
                var rows = data.table.body;
                var i;
                for (i = 1; i < 5; i++) {
                    if (data.row.index === rows.length - i) {
                        doc.setFont("Times-Roman", "bold");
                    }
                }
            };

            doc.autoTable({
                html: '#headerTabel',
                startY: doc.lastAutoTable + 63,
                theme: 'plain',
                styles: {
                    font: 'times',
                    lineColor: 'black',
                    textColor: 'black',
                    fontSize: '10.5',
                    cellPadding: 1
                },
                margin: { left: 10, right: 10 }
            });

            doc.autoTable({
                html: '#tabelMK',
                theme: 'grid',
                styles: {
                    font: 'times',
                    lineColor: 'black',
                    textColor: 'black',
                },
                headStyles: {
                    fillColor: [255, 255, 255],
                    lineColor: 'black',
                    halign: 'center',
                    cellWidth: 'wrap',
                    lineWidth: 0.1
                },
                columnStyles: {
                    0: { cellWidth: 8, halign: 'center' },
                    1: { cellWidth: 40, halign: 'center' },
                    3: { cellWidth: 90 },
                    5: { halign: 'center' },
                    6: { halign: 'center' },
                    7: { halign: 'center' },
                    8: { halign: 'center' },
                },
                margin: { top: 10, left: 10, right: 10, bottom: 10 },
                willDrawCell: drawCell,
            });

            doc.autoTable({
                html: '#ttd',
                theme: 'plain',
                styles: {
                    font: 'times',
                    lineColor: 'black',
                    textColor: 'black',
                    fontSize: '10.5',
                    cellPadding: 0.1
                },
                margin: { top: 20, left: 10, right: 10, bottom: 10 },
                columnStyles: {
                    0: { halign: 'center' },
                    1: { halign: 'center' }
                },
                didParseCell: function (data) {
                    var rows = data.table.body;
                    if (data.row.index === rows.length - 2) {
                        data.cell.styles.cellPadding = -4
                    }
                    if (data.row.index === rows.length - 1) {
                        data.cell.styles.cellPadding = 1
                    }
                }
            });

            window.open(doc.output('bloburl'), '_blank')
        })
    }

    getDataMahasiswa = async () => {
        const res = await getUser(localStorage.getItem('nim'))
        if (res) {
            console.log(res.data)
            this.setState({ dataMhs: res.data })
        }
    }

    getAllData = async () => {
        const nim = localStorage.getItem('nim');
        const allPromise = Promise.all([
            getUser(nim),
            getSemester(nim)
        ])

        const promises = await allPromise

        this.setState({
            user: promises[0].data,
            listSemester: promises[1].data,
            ttd1: promises[0].data.kaprodi,
            ttd2: promises[0].data.dosenwali,
        })
    }


    cekEvaluasi = async () => {
        try {
            const res = await getUser(localStorage.getItem('nim'))
            if (res) {
                this.setState({ dataMhs: res.data }, () => {
                    const { nim, ta, smtta, kurikulum } = this.state.dataMhs;
                    validasiEvaluasi(nim, ta, smtta, kurikulum).then(response => {
                        if (response.data.access) {
                            this.getAllData();
                        } else {
                            sendMessage(414);
                            this.props.history.push('/evaluasi')
                        }
                    }).catch(error => {
                        sendMessage(500);
                    })
                })
            }
        } catch (error) {
            sendMessage(500);
        }
    };


    inputSemester = async (e) => {
        this.setState({ isLoading: true })

        const datas = {
            nim: this.state.user.nim,
            semester: e.target.value,
            kurikulum: this.state.user.kurikulum
        }

        const res = await getNilai(datas)
        if (res) { this.setState({ listNilai: res.data.data, nilai: res.data, selectedSemester: e.target.value, isLoading: false }) }
    }

    detailNilai = (data) => {
        this.setState({ listDetailNilai: data.detail, detailNilai: data })
    }


    componentDidMount = () => {
        // this.cekEvaluasi()
        this.getAllData()
        this.getDataMahasiswa()
    };

    render() {

        // underline for report 
        var i;
        var output = "";
        for (i = 0; i < this.state.ttd1.length; i++) {
            output += "_";
        }

        var i2;
        let output2 = "";
        for (i2 = 0; i2 < this.state.ttd2.length; i2++) {
            output2 += "_";
        }
        // end underline for report 

        let bahasa = this.state.bahasa;

        const { user, selectedSemester } = this.state

        return (
            <Fragment>
                <div className="smooth mb-2">
                    <div className="col-md-12 mb-3">
                        <div className="row">
                            <div className="col-12 col-xl-8 mb-xl-0">
                                <p className="abu" style={{ fontSize: "15px", fontWeight: "bold", color: "#999999", textTransform: "capitalize" }}>
                                    Akademik&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Kartu Hasil Studi
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="card card-custom">
                        <div className="card-body">
                            <p className="card-title text-center" style={{ fontSize: "25px", marginTop: "10px", marginBottom: "35px" }}>
                                Kartu Hasil Studi
                            </p>
                            <div className="table-responsive pl-2 pr-2">
                                <table className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                                    <thead></thead>
                                    <tbody>
                                        <tr>
                                            <td>NIM</td>
                                            <td> : </td>
                                            <td>{user.nim}</td>

                                            <td>Angkatan</td>
                                            <td> : </td>
                                            <td>{user.angkatan}</td>
                                        </tr>
                                        <tr>
                                            <td>Nama</td>
                                            <td> : </td>
                                            <td>{parserText(user.nama)}</td>

                                            <td>Semester</td>
                                            <td> : </td>
                                            <td>
                                                <select onChange={this.inputSemester} className="form-control custom-width">
                                                    <option value='' hidden>- Pilih Semester -</option>
                                                    {
                                                        this.state.listSemester.map((v, index) => {
                                                            return (
                                                                <option key={index} value={v.semester}>{'Semester ' + v.semester}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <br />
                            <br />
                            <p className="card-title" style={{ fontSize: "17px", marginLeft: "10px" }}>
                                Laporan KHS & Detail Nilai :
                            </p>

                            {
                                this.state.isLoading
                                    ? <div id="loaderMhs">
                                        <div className="loader-1 colorful mt-5 mb-2">
                                            <div className="dot" />
                                            <div className="dot" />
                                            <div className="dot" />
                                        </div>
                                        <p align="center" className="mb-5">loading data...</p>
                                    </div>
                                    : <Fragment>
                                        <div className="table-responsive">
                                            <table width="100%" align="center" className="display expandable-table table-bordered table-radius"
                                            >
                                                <thead>
                                                    <tr align="center">
                                                        <th scope="row" style={{ borderRadius: '0px' }}>No</th>
                                                        <th colSpan={2}>Kode Mata Kuliah</th>
                                                        <th colSpan={2}>Nama Mata Kuliah</th>
                                                        <th>SKS</th>
                                                        <th>Nilai</th>
                                                        <th>Huruf</th>
                                                        <th>SKS x N</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.listNilai.length !== 0 ?
                                                            this.state.listNilai.map((list, i) => {
                                                                return (
                                                                    <tr height={10} key={i}>
                                                                        <td align="center">{i + 1}</td>
                                                                        <td colSpan={2} align="center">
                                                                            <button type="button"
                                                                                title="detail nilai mk"
                                                                                className="btn btn-primary btn-sm btn-nilai" data-toggle="modal" data-target="#nilai"
                                                                                onClick={() => this.detailNilai(list)}>
                                                                                {list.kodemk}
                                                                            </button>
                                                                        </td>
                                                                        <td>{list.kodemk}</td>
                                                                        <td align="center">{list.matakuliah}</td>
                                                                        <td align="center">{list.sks}</td>
                                                                        <td align="center">
                                                                            {list.nilai === 'BT' ? (
                                                                                <span className="badge badge-warning" style={{ fontSize: '13px' }}>
                                                                                    BT
                                                                                </span>
                                                                            ) : list.nilai}
                                                                        </td>
                                                                        <td align="center">
                                                                            {list.grade === 'BT' ? (
                                                                                <span
                                                                                    className="badge badge-danger"
                                                                                    title="BT = Belum Tampil. Nilai belum dipublikasikan oleh dosen."
                                                                                >
                                                                                    BT
                                                                                </span>
                                                                            ) : list.grade}
                                                                        </td>

                                                                        <td align="center">{list.sksn}</td>
                                                                    </tr>
                                                                )
                                                            }) : <tr><td className='text-center' colSpan={9}>-- Tidak Ada Data --</td></tr>
                                                    }
                                                </tbody>
                                                <tfoot>
                                                    <tr className="customPadding customTable">
                                                        <td colSpan={5}>Total</td>
                                                        <td align="center">{this.state.nilai.totalsks ?? "-"}</td>
                                                        <td align="center">-</td>
                                                        <td align="center">-</td>
                                                        <td align="center">{this.state.nilai.totalsksn ?? "-"}</td>
                                                    </tr>
                                                    <tr className="customPadding">
                                                        <td colSpan={8}>IP Semester</td>
                                                        <td align="center">{this.state.nilai.ips ?? "-"}</td>
                                                    </tr>
                                                    <tr className="customPadding customTable">
                                                        <td colSpan={8} className="no-border-right">IP Kumulatif</td>
                                                        <td align="center" className="no-border-left">{this.state.nilai.ipk ?? "-"}</td>
                                                    </tr>
                                                    <tr className="customPadding customTable">
                                                        <td colSpan={8}>Beban Maksimal SKS Semester Depan</td>
                                                        <td align="center">{this.state.nilai.batas_sks ?? "-"}</td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                        <br />

                                        <div className="dropdown mb-1" style={{ float: 'right' }}>
                                            <button className="btn btn-success dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <i className="fa fa-print"></i>&nbsp;&nbsp;Cetak KHS .PDF
                                            </button>
                                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                <a className="dropdown-item" href="#" onClick={() => this.print('indonesia', user.jurusan)}><i className="fa fa-print"></i>&nbsp;&nbsp;Bahasa Indonesia</a>
                                                <a className="dropdown-item" href="#" onClick={() => this.print('english', user.jurusan)}><i className="fa fa-print"></i>&nbsp;&nbsp;Bahasa Inggris</a>
                                            </div>
                                        </div>
                                    </Fragment>
                            }
                        </div>
                    </div>
                </div>

                {/* Modal */}
                <div className="modal fade" id="nilai" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    Detail Nilai <span style={{ color: '#8cb8ff' }}>[{this.state.detailNilai.kodemk}]</span> {this.state.detailNilai.matakuliah}
                                    <br />
                                    <br />
                                    <span style={{
                                        fontSize: '14px', backgroundColor: '#f29327', borderRadius: '30px',
                                        padding: '5px 15px 5px 15px', color: 'white'
                                    }}>{this.state.detailNilai.dosen}</span>
                                </h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true" className="close-btn">×</span></button>
                            </div>
                            <div className="pl-3 pr-3 pt-3 pb-5">
                                <div className="table-responsive">
                                    <table className="display expandable-table table-striped tableBord" style={{ width: '100%' }}>
                                        <thead>
                                            <tr>
                                                <th>Jenis Penilaian</th>
                                                <th>Persentase</th>
                                                <th>Angka</th>
                                                <th>Huruf</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.listDetailNilai.map((list, i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td>
                                                                {list.jenis == 'Praktikum' ? 'Unjuk Kerja' : list.jenis == 'Lain-Lain' ? 'Softskill' : list.jenis}
                                                            </td>
                                                            <td>{list.prosentase}</td>
                                                            <td>{list.nilai}</td>
                                                            <td>
                                                                {list.grade === 'BT'
                                                                    ? <b style={{ color: '#dc3545' }}>BT (Belum Tampil)</b>
                                                                    : list.grade}
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    className="alert alert-warning mt-3 mb-3"
                    role="alert"
                    style={{
                        fontWeight: 'bold',
                        fontSize: '15px',
                        borderLeft: '6px solid #856404',
                        backgroundColor: '#fff3cd'
                    }}
                >
                    ⚠️ <b>KETERANGAN NILAI</b><br />
                    <b>BT</b> = <span style={{ color: '#d39e00' }}>Belum Tampil</span><br />
                    Nilai mata kuliah belum dipublikasikan oleh dosen.
                </div>

                {/* print area  */}
                <div style={{ display: 'none' }}>
                    <div>
                        <table id="headerTabel">
                            <thead></thead>
                            <tbody className='times'>
                                <tr>
                                    <td>{bahasa == 'indonesia' ? 'Nama' : 'Name'}</td>
                                    <td> : </td>
                                    <td>{user.nama}</td>

                                    <td>{bahasa == 'indonesia' ? 'Tahun Angkatan' : 'Year'}</td>
                                    <td> : </td>
                                    <td>{user.angkatan}</td>
                                </tr>
                                <tr>
                                    <td>{bahasa == 'indonesia' ? 'NIM' : 'Student Number'}</td>
                                    <td> : </td>
                                    <td>{user.nim}</td>

                                    <td>{bahasa == 'indonesia' ? 'Tahun Akademik' : 'Academic Year'}</td>
                                    <td> : </td>
                                    <td>{user.ta}</td>
                                </tr>
                                <tr>
                                    <td>{bahasa == 'indonesia' ? 'Program Studi' : 'Major'}</td>
                                    <td> : </td>
                                    <td>
                                        {this.state.bahasa == "indonesia" ? user.jurusan : ProdiSwitch(user.jurusan)}
                                    </td>

                                    <td>Semester</td>
                                    <td> : </td>
                                    <td>{selectedSemester}</td>
                                </tr>
                                <tr>
                                    <td>{bahasa == 'indonesia' ? 'Konsentrasi' : 'Concentration'}</td>
                                    <td> : </td>
                                    <td>-</td>
                                </tr>
                            </tbody>
                        </table>

                        <table id="tabelMK">
                            <thead>
                                <tr align="center">
                                    <th scope="row">No</th>
                                    <th colSpan={2}>{bahasa == 'indonesia' ? 'Kode Mata Kuliah' : 'Course Code'}</th>
                                    <th colSpan={2}>{bahasa == 'indonesia' ? 'Nama Mata Kuliah' : 'Course Name'}</th>
                                    <th>{bahasa == 'indonesia' ? 'SKS' : 'Credit'}</th>
                                    <th>{bahasa == 'indonesia' ? 'Nilai' : 'Score'}</th>
                                    <th>{bahasa == 'indonesia' ? 'Huruf' : 'Grade'}</th>
                                    <th>{bahasa == 'indonesia' ? 'SKS x N' : 'Credit x S'}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.listNilai.map((list, i) => (
                                        <tr key={i}>
                                            <td>{i + 1}</td>
                                            <td colSpan={2}>
                                                {list.kodemk}
                                            </td>
                                            <td colSpan={2}>
                                                {bahasa == 'indonesia' ? list.matakuliah : 'Game Development'}
                                            </td>
                                            <td>{list.sks}</td>
                                            <td>{list.nilai}</td>
                                            <td>{list.grade}</td>
                                            <td>{list.sksn}</td>
                                        </tr>
                                    )
                                    )}
                                <tr>
                                    <td colSpan={5}>&nbsp;<b>Total</b></td>
                                    <td>{this.state.nilai.totalsks ?? "-"}</td>
                                    <td>-</td>
                                    <td>-</td>
                                    <td>{this.state.nilai.totalsksn ?? "-"}</td>
                                </tr>
                                <tr>
                                    <td colSpan={8}>{bahasa == 'indonesia' ? 'IP Semester' : 'GP Semester'}</td>
                                    <td>{this.state.nilai.ips ?? "-"}</td>
                                </tr>
                                <tr>
                                    <td colSpan={8}> {bahasa == 'indonesia' ? 'IP Kumulatif' : 'Grade Point Average'}</td>
                                    <td>{this.state.nilai.ipk ?? "-"}</td>
                                </tr>
                                <tr>
                                    <td colSpan={8}>{bahasa == 'indonesia' ? 'Beban Maksimal SKS Semester Depan' : 'Maximum Load of Credits for Next Semester'}</td>
                                    <td align="center">{this.state.nilai.batas_sks ?? "-"}</td>
                                </tr>
                            </tbody>
                        </table>


                        <table id="ttd">
                            <thead></thead>
                            <tbody>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>Malang,  {tanggal}</td>
                                </tr>
                                <tr>
                                    <td>{bahasa == 'indonesia' ? 'Mengetahui,' : 'Regard,'}</td>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>{bahasa == 'indonesia' ? 'Kepala Program Studi,' : 'Head of Study Program,'}</td>
                                    <td>{bahasa == 'indonesia' ? 'Dosen Wali,' : 'Lecturer,'}</td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>
                                        {this.state.user.kaprodi}
                                    </td>
                                    <td>
                                        {this.state.user.dosenwali}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        {output}
                                    </td>
                                    <td>
                                        {output2}
                                    </td>
                                </tr>
                                <tr>
                                    <td>NIDN. {this.state.user.nidn_kaprodi}</td>
                                    <td>NIDN. {this.state.user.nidn}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                {/* end of print area  */}
            </Fragment >
        );
    }
}

export default Khs;
